import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import classnames from "classnames";

import { ToYou, ToYourFriends } from "components/mgm/GiftsAndDiscounts";
import { ShareFriends, ShareSocials } from "components/mgm/Share";
import { InvitesTotal, InvitesListSended } from "components/mgm/Invites";
import { Tabs } from "components/general/Tabs";
import { Tab } from "components/general/Tab";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";

import Styles from "views/pages/ChamaAsAmigas.module.scss";
import { UiActions } from "state/actions/UiActions";
import GiftCard from "components/mgm/GiftCard";
import { giftCardsList } from "components/mgm/data/giftCardsList";

class ChamaAsAmigas extends Component {
  constructor(props) {
    super(props);

    this.state = {
      invitesList: [],
      subPage: props.match.params.subPage || null,
    };

    this.copyToClipBoard = this.copyToClipBoard.bind(this);
  }

  copyToClipBoard = (id) => {
    return (event) => {
      event.preventDefault();
      let valToCopy = document.getElementById(id).innerText;
      let textarea = document.createElement("textarea");

      textarea.innerText = valToCopy;
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      document.execCommand("copy");
      textarea.remove();

      this.props.publishSuccessAlert("Copiado com sucesso!");
    };
  };

  componentDidMount() {
    ExecuteRequest(
      GlamboxEndpoints.Person.listInvites,
      null,
      "GET",
      {
        Authorization: this.props.token.Authorization,
      },
      null,
      (response) => {
        let { result, statusCode } = response;

        if (statusCode === 200) {
          this.setState({
            invitesList: result,
          });
        }
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { person, match, history } = this.props;

    if (match.params.subPage !== prevProps.match.params.subPage) {
      this.setState({
        subPage: match.params.subPage || null,
      });
    }
  }

  render() {
    const { person, match, history } = this.props;

    let classes = ["gbBt"];
    classes.push("small");
    classes.push("flat");

    let selectedTab = "";
    if (match.params.subPage) {
      selectedTab = this.state.subPage;
    }

    return (
      <div className={"p-2 p-lg-5"}>
        <Helmet>
          <title>Minha Glambox : Chama as Amigas</title>
        </Helmet>

        <h1>Chama as Amigas</h1>
        <p>Convide elas e ganhe prêmios!</p>

        <Tabs activeTab={selectedTab} parentPage={"/chama-as-amigas"}>
          <Tab label={"Geral"} tabId={"geral"} className={""}>
            <div
              className={"gb-contentblock p-xl-5 p-3 level-2"}
              style={{ marginBottom: "0" }}
            >
              <p>
                Agora que você já sabe de todos os{" "}
                <strong>benefícios de ser uma Glamgirl</strong>, chegou a hora
                de divulgar essa experiência para suas amigas! Convide-as para
                assinar a Glambox e confira tudo o que você pode ganhar.
              </p>
            </div>

            <ShareFriends person={person.person} />
            <ShareSocials couponName={person.person.couponName} />

            <ToYou badge={person.badge} />

            <div className={"level-2"}>
              <ToYourFriends
                gift={false}
                discountM={true}
                discountS={true}
                discountY={true}
                anual={80}
                semestral={30}
                // countdownTo={"2020/06/28 00:00:00"}
              />
              <div id={Styles["promoGlamgirl"]}>
                <div className={Styles["linha"]}>
                  <div className={Styles["logo-text"]}>
                    <img
                      className={Styles["logo"]}
                      src={
                        "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21048.png"
                      }
                      alt={"play na glamfriday"}
                    />
                    {/* <img
                      className={Styles['logoDesk']}
                      src={'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_20574.png'}
                      alt={'Make completa com Eudora para as suas seguidoras!'}
                    /> */}
                    <p>
                      Assinando com seu cupom, suas amigas vão ganhar um
                      desconto exclusivo de{" "}
                      <strong>R$100 + uma caixinha EXTRA!</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/*
            <div className={"level-2"}>
              <ToYourFriends
                gift
                anual={80} />
              <div className={Styles["edicaoAtual"]}>
                <div className={classnames(Styles["content"], Styles["noImage"])}>
                  <h2>R$100 OFF anual!</h2>
                  <div>
                    <p>
                      Assinando agora o plano anual, <strong>sua amiga ganha um super desconto de R$100 OFF!</strong> Divulgue seu cupom personalizado já e traga sua amiga para fazer parte do maior clube de assinatura da América Latina!
                    </p>
                  </div>
                </div>
              </div>
            </div>
            */}

            <div
              className={"gb-contentblock p-xl-4 p-3 level-2"}
              style={{ marginTop: "15px" }}
            >
              <p>
                Para ajudar ainda mais nas suas divulgações, baixe as fotos
                abaixo e poste junto com seu cupom e link personalizado.
              </p>
              <div className={Styles["images-download"]}>
                <div>
                  <img
                    src={
                      "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_20968.jpg"
                    }
                    alt={""}
                  />
                  <a
                    href={
                      "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_20968.jpg"
                    }
                    className={"btn btn-sm btn-light-pink m-auto"}
                    target="_blank"
                    rel="noopener noreferrer"
                    download={true}
                  >
                    Baixar imagem
                  </a>
                </div>
                <div>
                  <img
                    src={
                      "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_20969.jpg"
                    }
                    alt={""}
                  />
                  <a
                    href={
                      "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_20969.jpg"
                    }
                    className={"btn btn-sm btn-light-pink m-auto"}
                    target="_blank"
                    rel="noopener noreferrer"
                    download={true}
                  >
                    Baixar imagem
                  </a>
                </div>

                <div>
                  <img
                    src={
                      "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21044.PNG"
                    }
                    alt={""}
                  />
                  <a
                    href={
                      "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21045.mp4"
                    }
                    className={"btn btn-sm btn-light-pink m-auto"}
                    target="_blank"
                    rel="noopener noreferrer"
                    download={true}
                  >
                    Baixar video
                  </a>
                </div>
              </div>
            </div>
          </Tab>

          <Tab label={"Concurso"} tabId={"concurso"}>
            <div
              className={classnames(
                "gb-contentblock",
                Styles["concurso_mgm"],
                Styles["other"],
                "mb-2"
              )}
            >
              {/* <div id={Styles['cmgmPromoRelampago']}>
                <div className={Styles['linha']}>
                  <div className={Styles['text-container']}>
                    <img
                      className={Styles['logo']}
                      src={
                        'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_20552.png'
                      }
                      alt={'promoção relampago!'}
                    />
                    <p>
                      Esses <strong>4 kits incríveis que valem + de R$300</strong> serão sorteados
                      entre todas as Glamgirls que trouxerem pelo menos UMA amiga para a Glambox até
                      o dia <strong>16/08!</strong>
                    </p>
                    <p>E quanto mais amigas trouxer, mais chances de ganhar!</p>
                    <p>
                      <small>
                        *Válido para todos os planos | *Válido do dia 12/08 a 16/08 | *Será enviado
                        junto a sua edição do mês seguinte
                      </small>
                    </p>
                  </div>
                  <img
                    className={Styles['pack-mobile']}
                    src={'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_20551.gif'}
                    alt={'kits com várias produtos'}
                  />
                  <img
                    className={Styles['pack-desktop']}
                    src={'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_20553.gif'}
                    alt={'kits com várias produtos'}
                  />
                </div>
              </div> */}

              <p className={Styles["title"]}>
                Concorra ao <strong>sorteio do mês</strong>
              </p>

              <div id={Styles["mgmConcurso"]}>
                <div className={Styles["linha"]}>
                  <div className={Styles["text-logo"]}>
                    <img
                      className={Styles["logo"]}
                      src={
                        "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_20950.png"
                      }
                      alt={"quatro mil reais em produtos premium"}
                    />
                    <div className={Styles["text-container"]}>
                      <p>
                        Traga apenas <strong>UMA</strong> amiga para assinar a
                        Glambox e concorra ao sorteio de um{" "}
                        <strong>
                          kit completo da Kérastase + acessórios para os seus
                          fios!
                        </strong>
                        <br />
                        <br />
                        Divulgue já seu cupom{" "}
                        <strong>{person.person.couponName}</strong>!
                      </p>
                      <small>
                        *Promoção válida até 31/11 | *Válido para indicações em
                        todos os planos | *Os prêmios serão enviados junto a sua
                        edição do mês seguinte
                      </small>
                    </div>
                  </div>
                  {/* <div className={Styles['pack']}>
                    <img
                      className={Styles['mobile']}
                      src="https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_19521.gif"
                      alt="gif com vários produtos de skincare"
                    />
                    <img
                      className={Styles['desk']}
                      src="https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_19522.gif"
                      alt="gif com vários produtos de skincare"
                    />
                  </div> */}
                </div>
              </div>

              <div id={Styles["mgmExtraBox"]}>
                <div className={Styles["linha"]}>
                  <div className={Styles["text-logo"]}>
                    <img
                      className={Styles["logo"]}
                      src={
                        "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21030.png"
                      }
                      alt={"sua chance de participar do Glamstar chegou!"}
                    />
                    <div className={Styles["text-container"]}>
                      <p>
                        <strong>Trazendo 3 amigas para a Glambox</strong> com
                        seu cupom {person.person.couponName}{" "}
                        <strong>
                          você leva esse prêmio incrível com{" "}
                          <span>R$300 em produtos!</span>
                        </strong>
                      </p>
                      <small>
                        *Válido do dia 05/11 a 30/11 | *Válido apenas para
                        indicações nos planos anual e semestral | *O prêmio será
                        enviado com sua edição do mês seguinte
                      </small>
                    </div>
                  </div>
                  {/* <div className={Styles['pack']}>
                    <img
                      className={Styles['mobile']}
                      src="https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_19521.gif"
                      alt="gif com vários produtos de skincare"
                    />
                    <img
                      className={Styles['desk']}
                      src="https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_19522.gif"
                      alt="gif com vários produtos de skincare"
                    />
                  </div> */}
                </div>
              </div>

              <div id={Styles["mgmChallenge"]}>
                <div className={Styles["linha"]}>
                  <div className={Styles["text-logo"]}>
                    <img
                      className={Styles["logo"]}
                      src={
                        "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21004.png"
                      }
                      alt={"sua chance de participar do Glamstar chegou!"}
                    />
                    <div className={Styles["text-container"]}>
                      <p>
                        <strong>
                          As 50 Glamgirls que mais trouxerem amigas para a
                          Glambox,
                        </strong>{" "}
                        vão garantir uma vaga para participar da competição que
                        vai revelar a maior influenciadora do Brasil!
                      </p>
                      <small>
                        *Promoção válida do dia 01/11 até 31/12 | *Tenha pelo
                        menos 3 mil seguidores no Insta, TikTok e/ou YouTube ou
                        3 mil seguidores somando essas 3 redes sociais | *Sua
                        assinatura deve estar ativa
                      </small>
                    </div>
                  </div>
                  {/* <div className={Styles['pack']}>
                    <img
                      className={Styles['mobile']}
                      src="https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_19521.gif"
                      alt="gif com vários produtos de skincare"
                    />
                    <img
                      className={Styles['desk']}
                      src="https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_19522.gif"
                      alt="gif com vários produtos de skincare"
                    />
                  </div> */}
                </div>
              </div>
            </div>

            <p className={Styles["title"]}>
              Garanta 5 produtos extras com sua próxima Glambox!
            </p>

            <div className={Styles["gifts-container"]}>
              {giftCardsList.map((card) => {
                return (
                  <GiftCard
                    number={card.number}
                    text={card.text}
                    img={card.img}
                    backgroundColor={card.backgroundColor}
                  />
                );
              })}
            </div>
            <p className={Styles["small"]}>
              *Válido apenas para as 1000 primeiras Glamgirls que trouxerem
              amigas nos planos <strong>anual ou semestral</strong> | *Será
              entregue junto a sua edição do mês seguinte | *Brindes cumulativos
            </p>
            <ShareSocials couponName={person.person.couponName} />
          </Tab>

          <Tab label={"Cupom"} tabId={"cupom"}>
            <InvitesTotal
              person={person.person}
              invites={this.state.invitesList}
            />
            <InvitesListSended
              person={person.person}
              invites={this.state.invitesList}
            />
          </Tab>
        </Tabs>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  person: state.person.data,
  token: state.token.data,
});

const mapDispatchToProps = (dispatch) => ({
  publishSuccessAlert: (message) => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
});

ChamaAsAmigas = connect(mapStateToProps, mapDispatchToProps)(ChamaAsAmigas);

export { ChamaAsAmigas };
